import React from 'react';
import { Nav } from 'rsuite';

export default function Tabs ({ className, items, selected, onSelect }) {
    return (
        <Nav
            className={className}
            activeKey={selected}
            onSelect={onSelect}
        >
            {items.map(item => (
                <Nav.Item id={item.id} key={item.id} eventKey={item} active={item.id === selected.id}>
                    {item.label}
                </Nav.Item>
            ))}
        </Nav>
    );
}
